import { withControlledField } from '../ControlledField';
import { ColorFieldWrapper } from './ColorFieldWrapper';

export const ControlledColorField = withControlledField(ColorFieldWrapper);
